/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React, { useEffect, useRef, useState } from "react";
import {
	StyleSheet,
	Image,
} from "react-native";

import ImageUrl from "ae-base/Base/ImageUrl";
import Style from "ae-style";
import { useResources } from "@aetonix/hooks";


var MAX_IMAGE_RETRIES = 4;
var IMAGE_RETRY_DELAYS_MS = [500, 1000, 2000, 4000];

var imageSizes = Object.keys(Style.imageSize);

var imageStyles = StyleSheet.create(imageSizes.reduce(function(style, name){
	var size = Style.imageSize[name];

	var borderWidth = (size > 100) ? 4 : 2;

	style[name] = {
		width: size,
		height: size,
		borderRadius: (size + borderWidth) / 2,
		borderWidth: borderWidth,
	};

	return style;
}, {}));

var styles = StyleSheet.create({
	image: {
		alignItems: "center",
		justifyContent: "center",
		overflow: "hidden",
		opacity: 0.999,
		alignSelf: "center",
	},
	inactive: {
		opacity: 0.5,
	},
});

export default function Avatar(props){
	const { config } = useResources();

	var person = props.person || {};
	var inactive = props.inactive;
	var children = props.children;
	var size = props.size ? props.size : "large";
	var imageSize = imageStyles[size];
	var borderColor = props.borderColor ? props.borderColor : Style.look.outline;
	var imageBorder = {
		borderColor: borderColor,
	};

	var imageStyle =  [styles.image, imageSize, imageBorder];

	if(inactive)
		imageStyle.push(styles.inactive);

	var baseSource = ImageUrl(person.image, config);
	var hasRemoteUri = !!(baseSource && baseSource.uri);

	const [retryToken, setRetryToken] = useState(0);
	const retryCountRef = useRef(0);
	const retryTimerRef = useRef(null);
	const lastImageRef = useRef(person.image);

	useEffect(function(){
		if(lastImageRef.current !== person.image){
			lastImageRef.current = person.image;
			retryCountRef.current = 0;
			if(retryTimerRef.current){
				clearTimeout(retryTimerRef.current);
				retryTimerRef.current = null;
			}
			setRetryToken(0);
		}
	}, [person.image]);

	useEffect(function(){
		return function(){
			if(retryTimerRef.current){
				clearTimeout(retryTimerRef.current);
				retryTimerRef.current = null;
			}
		};
	}, []);

	var source = baseSource;
	if(hasRemoteUri && retryToken > 0){
		var separator = baseSource.uri.indexOf("?") === -1 ? "?" : "&";
		source = Object.assign({}, baseSource, {
			uri: baseSource.uri + separator + "_r=" + retryToken,
		});
	}

	var onError = null;
	if(hasRemoteUri){
		onError = function(){
			if(retryCountRef.current >= MAX_IMAGE_RETRIES) return;
			var delay = IMAGE_RETRY_DELAYS_MS[retryCountRef.current] || 4000;
			retryCountRef.current += 1;
			if(retryTimerRef.current) clearTimeout(retryTimerRef.current);
			retryTimerRef.current = setTimeout(function(){
				retryTimerRef.current = null;
				setRetryToken(Date.now());
			}, delay);
		};
	}

	return (
		<Image
			resizeMethod="resize"
			source={source}
			style={imageStyle}
			key={person._id + ":" + retryToken}
			onError={onError}>
			{children}
		</Image>
	);
}
